import type { Cue } from '~shared/rundown/cue'
import type { ReadonlyRundownCueOrderItem } from '~shared/rundown/rundown'

/**
 * Flatten a (possibly nested) cue-order tree into a flat list of cue ids, in
 * document order, descending into group children.
 */
export function flattenCueOrderItems(items: readonly ReadonlyRundownCueOrderItem[]): Cue['id'][] {
  return items.reduce<Cue['id'][]>((acc, item) => {
    acc.push(item.id)
    if (item.children) acc.push(...flattenCueOrderItems(item.children))
    return acc
  }, [])
}
